import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function SalaryPayList() {
  const navigate = useNavigate();
  const columns = [
    { field: "SPFL_Id", label: "#" },
    { field: "SPFL_Name", label: "Salary Pay Type" },
    { field: "SPFL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.SPFL_Id));

        navigate(
          `/SalaryPayLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ];

  return (
    <DynamicTable
      columns={columns}
      actions={actions}
      dataAPI={`/SalaryPayFrequency/list`}
      title={`Salary Pay`}
      linkvalue={`/SalaryPayLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default SalaryPayList;
